import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Inject, Injectable, Optional } from "@angular/core";
import { API_BASE_URL } from "@shared/clients/api.generated";
import { Observable } from "rxjs";
import { ElectionContextProviderService } from "@shared/services/election-context-provider.service";


@Injectable()
export class ElectionContextHttpInterceptor implements HttpInterceptor {
  private static readonly electionIdHeaderKey = 'X-Election-ID';
  private readonly baseApiUrl: string;

  constructor(
    private readonly electionContextProvider: ElectionContextProviderService,
    @Optional() @Inject(API_BASE_URL) baseUrl?: string
  ) {
    this.baseApiUrl = (baseUrl !== undefined && baseUrl !== null ? baseUrl : '') + '/api/';
  }
  // eslint-disable-next-line
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let request = req;
    if (request.url.includes(this.baseApiUrl)) {
      let electionId = this.electionContextProvider.electionId;
      if (electionId) {
        request = req.clone({
          headers: req.headers.set(
            ElectionContextHttpInterceptor.electionIdHeaderKey,
            electionId
          )
        })
      }
    }

    return next.handle(request);
  }
}
